import React, { useContext } from 'react'

import { Show } from '../../../../components/Show'
import { useCan } from '../../../../hooks/useCan'
import { can } from '../../../../config/permissions'
import { AuthContext } from '../../../../contexts/AuthContext'
import { usePerson } from './hooks/usePerson'

import { PersonFormProvider } from './context'
import { PersonMain, ApiKeysTable } from './components'

export const PersonForm: React.FC = () => {
  const canReadApiKeys = useCan(can.person.readApiKeys)
  const { user } = useContext(AuthContext)
  const { updatePerson } = usePerson()

  const handlePersonSubmit = (values: any) => {
    updatePerson(values)
    // Add any post-submission logic here, e.g., redirect, show toast
  }

  return (
    <PersonFormProvider>
      <PersonMain onSubmit={handlePersonSubmit} />
      <Show
        condition={canReadApiKeys && user?.role === 'ADMIN'}
        component={<ApiKeysTable />}
      />
    </PersonFormProvider>
  )
}
